import { FC } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './SessionExpired.module.scss';
import RefreshIcon from '@mui/icons-material/Refresh';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const SessionExpired: FC = () => {
  const navigate = useNavigate();

  const handleRefreshSession = (): void => {
    navigate('/');
  };

  return (
    <div className={styles.sessionExpired}>
      <div className={styles.iconContainer}>
        <AccessTimeIcon className={styles.timeIcon} />
      </div>

      <h1 className={styles.title}>Session Expired</h1>

      <p className={styles.description}>
        Your session has expired for security reasons. Please refresh your session to continue using the application.
      </p>

      <div className={styles.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRefreshSession}
          startIcon={<RefreshIcon />}
          className={styles.primaryButton}
          size="large"
        >
          Refresh Session
        </Button>
      </div>

      <div className={styles.helpText}>
        <p>Operational Metadata Store</p>
      </div>
    </div>
  );
};

export default SessionExpired;
